<template>
  <section class="product-workspace">
    <table-toolbar
      :search.sync="search"
      :show-search="true"
      :show-refresh="true"
      :show-export="showExportBtn"
      :show-column-settings="true"
      :columns="columnOptions"
      :visible-columns.sync="visibleColumns"
      :default-columns="defaultVisibleColumns"
      :fixed-columns="['# ID', '游戏名称', '操作']"
      :min-selected="4"
      @refresh="handleRefresh"
      @export="handleExport"
      @search-change="handleFilterChange"
    >
      <template slot="left">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAddProduct" class="btn-action">新增游戏</el-button>
        <cache-reload reload-type="game" size="small" btn-label="重载NACOS-游戏" class="reload-wrapper" />
      </template>

    </table-toolbar>

    <table-page
      :loading="loading"
      :empty="filteredTables.length === 0"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :total="filteredTables.length"
      :page-sizes="[10, 20, 30, 50, 100, 200]"
      :show-top-pagination="filteredTables.length > pageSize"
      :show-bottom-pagination="filteredTables.length > pageSize"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      @retry="handleRefresh"
    >
      <el-table
        :data="pagedTables"
        stripe
        style="width: 100%"
        class="premium-table"
      >
        <el-table-column key="col-id" prop="id" width="80">
          <template slot="header">
            <span class="premium-header-title"><span class="header-icon-hash">#</span> ID</span>
          </template>
          <template slot-scope="scope">
            <span class="cell-id">{{ scope.row.id }}</span>
          </template>
        </el-table-column>

        <el-table-column key="col-name" prop="name" label="游戏名称" min-width="160">
          <template slot-scope="scope">
            <el-link type="primary" class="cell-product-name" @click="handleUpdateProduct(scope.$index, scope.row)">
              {{ scope.row.name }}
            </el-link>
          </template>
        </el-table-column>

        <el-table-column key="col-companyId" v-if="visibleColumns.includes('companyId')" prop="companyId" label="公司" min-width="150">
          <template slot-scope="scope">
            <span class="cell-text">{{ companyFormatter(scope.row, null, scope.row.companyId) }}</span>
          </template>
        </el-table-column>

        <el-table-column key="col-ufoGroup" v-if="visibleColumns.includes('ufoGroup')" prop="ufoGroup" label="UFO分组" min-width="110">
          <template slot-scope="scope">
            <span class="cell-text-gray">{{ scope.row.ufoGroup || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column key="col-appKey" v-if="visibleColumns.includes('appKey')" prop="appKey" label="AppKey" width="120">
          <template slot-scope="scope">
            <ext-text-popover :content="scope.row.appKey" v-if="scope.row.appKey" />
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>

        <el-table-column key="col-appSecret" v-if="visibleColumns.includes('appSecret')" prop="appSecret" label="AppSecret" width="120">
          <template slot-scope="scope">
            <ext-text-popover :content="scope.row.appSecret" v-if="scope.row.appSecret" />
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>

        <el-table-column key="col-qyAppKey" v-if="visibleColumns.includes('qyAppKey')" prop="qyAppKey" label="QyAppKey" width="120">
          <template slot-scope="scope">
            <ext-text-popover :content="scope.row.qyAppKey" v-if="scope.row.qyAppKey" />
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>

        <el-table-column key="col-qyGroupId" v-if="visibleColumns.includes('qyGroupId')" prop="qyGroupId" label="QyGroupId" width="120">
          <template slot-scope="scope">
            <ext-text-popover :content="scope.row.qyGroupId" v-if="scope.row.qyGroupId" />
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>

        <el-table-column key="col-notifyUrl" v-if="visibleColumns.includes('notifyUrl')" prop="notifyUrl" label="CP-NotifyUrl" width="150">
          <template slot-scope="scope">
            <ext-text-popover :content="scope.row.notifyUrl" v-if="scope.row.notifyUrl" />
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>

        <el-table-column key="col-h5LoginUrl" v-if="visibleColumns.includes('h5LoginUrl')" prop="h5LoginUrl" label="CP-H5Url" width="130">
          <template slot-scope="scope">
            <ext-text-popover :content="scope.row.h5LoginUrl" v-if="scope.row.h5LoginUrl" />
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>

        <el-table-column key="col-gameUrl" v-if="visibleColumns.includes('gameUrl')" prop="gameUrl" label="CP-微端Url" width="130">
          <template slot-scope="scope">
            <ext-text-popover :content="scope.row.gameUrl" v-if="scope.row.gameUrl" />
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>

        <el-table-column key="col-products" v-if="visibleColumns.includes('products')" prop="products" label="商品挡位" min-width="160">
          <template slot-scope="scope">
            <div class="products-tag-container" @click="handleUpdateCurrency(scope.$index, scope.row)">
              <template v-if="productsToStr(scope.row.products) && productsToStr(scope.row.products).length">
                <el-tag
                  v-for="price in productsToStr(scope.row.products).slice(0, 3)"
                  :key="price"
                  size="mini"
                  type="info"
                  class="product-price-tag"
                >
                  ¥{{ price }}
                </el-tag>
                <el-tag v-if="productsToStr(scope.row.products).length > 3" size="mini" type="info" class="product-price-tag more-tag">
                  +{{ productsToStr(scope.row.products).length - 3 }}
                </el-tag>
              </template>
              <span v-else class="text-muted">-</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column key="col-minAge" v-if="visibleColumns.includes('minAge')" prop="minAge" label="适龄" width="90" align="center">
          <template slot-scope="scope">
            <span class="cell-text-gray">{{ scope.row.minAge }}</span>
          </template>
        </el-table-column>

        <el-table-column key="col-bizId" v-if="visibleColumns.includes('bizId')" prop="bizId" label="bizId" width="100">
          <template slot-scope="scope">
            <ext-text-popover :content="scope.row.bizId" v-if="scope.row.bizId" />
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>

        <el-table-column key="col-realAuthOpen" v-if="visibleColumns.includes('realAuthOpen')" prop="realAuthOpen" label="实名" width="90" align="center">
          <template slot-scope="scope">
            <span :class="['status-simple-badge', scope.row.realAuthOpen ? 'active' : 'inactive']">
              <span class="dot"></span>
              {{ scope.row.realAuthOpen ? '开启' : '关闭' }}
            </span>
          </template>
        </el-table-column>

        <el-table-column key="col-juvenileOpen" v-if="visibleColumns.includes('juvenileOpen')" prop="juvenileOpen" label="防沉迷" width="90" align="center">
          <template slot-scope="scope">
            <span :class="['status-simple-badge', scope.row.juvenileOpen ? 'active' : 'inactive']">
              <span class="dot"></span>
              {{ scope.row.juvenileOpen ? '开启' : '关闭' }}
            </span>
          </template>
        </el-table-column>

        <el-table-column key="col-status" v-if="visibleColumns.includes('status')" prop="status" label="状态" width="110">
          <template slot-scope="scope">
            <span :class="['status-dot-badge', getStatusClass(scope.row.status)]">
              <span class="dot"></span>
              {{ getStatusLabel(scope.row.status) }}
            </span>
          </template>
        </el-table-column>

        <el-table-column key="col-plutoOpen" v-if="visibleColumns.includes('plutoOpen')" prop="plutoOpen" label="Pluto" width="90" align="center">
          <template slot-scope="scope">
            <span :class="['status-simple-badge', scope.row.plutoOpen ? 'active' : 'inactive']">
              <span class="dot"></span>
              {{ scope.row.plutoOpen ? '开启' : '关闭' }}
            </span>
          </template>
        </el-table-column>

        <el-table-column key="col-ufwOpen" v-if="visibleColumns.includes('ufwOpen')" prop="ufwOpen" label="UFW" width="90" align="center">
          <template slot-scope="scope">
            <span :class="['status-simple-badge', scope.row.ufwOpen ? 'active' : 'inactive']">
              <span class="dot"></span>
              {{ scope.row.ufwOpen ? '开启' : '关闭' }}
            </span>
          </template>
        </el-table-column>

        <el-table-column key="col-phoneBindOpen" v-if="visibleColumns.includes('phoneBindOpen')" prop="phoneBindOpen" label="手机号绑定" width="105" align="center">
          <template slot-scope="scope">
            <span :class="['status-simple-badge', scope.row.phoneBindOpen ? 'active' : 'inactive']">
              <span class="dot"></span>
              {{ scope.row.phoneBindOpen ? '开启' : '关闭' }}
            </span>
          </template>
        </el-table-column>

        <el-table-column key="col-uninstallMenuOpen" v-if="visibleColumns.includes('uninstallMenuOpen')" prop="uninstallMenuOpen" label="卸载菜单栏" width="105" align="center">
          <template slot-scope="scope">
            <span :class="['status-simple-badge', scope.row.uninstallMenuOpen ? 'active' : 'inactive']">
              <span class="dot"></span>
              {{ scope.row.uninstallMenuOpen ? '开启' : '关闭' }}
            </span>
          </template>
        </el-table-column>

        <el-table-column key="col-transferOpen" v-if="visibleColumns.includes('transferOpen')" prop="transferOpen" label="转端开关" width="95" align="center">
          <template slot-scope="scope">
            <span :class="['status-simple-badge', scope.row.transferOpen ? 'active' : 'inactive']">
              <span class="dot"></span>
              {{ scope.row.transferOpen ? '开启' : '关闭' }}
            </span>
          </template>
        </el-table-column>

        <el-table-column key="col-actions" width="80" align="center">
          <template slot="header">
            <span class="premium-header-title">操作</span>
          </template>
          <template slot-scope="scope">
            <el-dropdown @command="handleActionCommand($event, scope.row, scope.$index)" trigger="hover">
              <el-button size="mini" class="action-btn" circle icon="el-icon-more-outline"></el-button>
              <el-dropdown-menu slot="dropdown" class="premium-dropdown-menu">
                <el-dropdown-item command="edit">
                  <i class="el-icon-edit-outline"></i> 编辑游戏
                </el-dropdown-item>
                <el-dropdown-item command="currency">
                  <i class="el-icon-coin"></i> 金额配置
                </el-dropdown-item>
                <el-dropdown-item command="delete" divided style="color: #ef4444;">
                  <i class="el-icon-delete" style="color: #ef4444;"></i> 删除游戏
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </table-page>

    <product-dialog
      :productData="productData"
      :dialogVisible="productDialogVisible"
      @handleSaveProductDialog="handleProductDialogChange"
      @handleCloseProductDialog="productDialogVisible=false"
    ></product-dialog>
    <currency-dialog
      :productData="productData"
      :dialogVisible="currencyDialogVisible"
      @handleSaveCurrencyDialog="handleCurrencyDialogChange"
      @handleCloseCurrencyDialog="currencyDialogVisible=false"
    ></currency-dialog>

  </section>
</template>

<script>
import ProductDialog from './ProductDialog'
import CurrencyDialog from './CurrencyDialog'
import options from '@/common/options'
import api from '@/api/channel'
import f from '@/filter'
import CacheReload from '@/components/CacheReload/index.vue'
import ExtTextPopover from '@/components/ExtTextPopover/index.vue'
import TablePage from '@/components/TablePage/index.vue'
import TableToolbar from '@/components/TableToolbar/index.vue'
import * as XLSX from 'xlsx'

export default {
  name: 'index',
  components: { CacheReload, ProductDialog, CurrencyDialog, ExtTextPopover, TablePage, TableToolbar },
  created () {
    this.fetchData()
  },
  data () {
    return {
      loading: false,
      productStatusOption: options.productStatusOption,
      tableData: [],
      companyData: [],
      search: '',
      showExportBtn: true,
      pageSize: 20,
      currentPage: 1,
      productDialogVisible: false,
      currencyDialogVisible: false,
      productData: {},
      defaultVisibleColumns: [
        'companyId', 'ufoGroup', 'appKey', 'appSecret', 'notifyUrl', 'products', 'status', 'realAuthOpen', 'juvenileOpen'
      ],
      visibleColumns: [
        'companyId', 'ufoGroup', 'appKey', 'appSecret', 'notifyUrl', 'products', 'status', 'realAuthOpen', 'juvenileOpen'
      ],
      columnOptions: [
        { prop: 'companyId', label: '公司' },
        { prop: 'ufoGroup', label: 'UFO分组' },
        { prop: 'appKey', label: 'AppKey' },
        { prop: 'appSecret', label: 'AppSecret' },
        { prop: 'qyAppKey', label: 'QyAppKey' },
        { prop: 'qyGroupId', label: 'QyGroupId' },
        { prop: 'notifyUrl', label: 'CP-NotifyUrl' },
        { prop: 'h5LoginUrl', label: 'CP-H5Url' },
        { prop: 'gameUrl', label: 'CP-微端Url' },
        { prop: 'products', label: '商品挡位' },
        { prop: 'minAge', label: '适龄' },
        { prop: 'bizId', label: 'bizId' },
        { prop: 'realAuthOpen', label: '实名' },
        { prop: 'juvenileOpen', label: '防沉迷' },
        { prop: 'status', label: '状态' },
        { prop: 'plutoOpen', label: 'Pluto' },
        { prop: 'ufwOpen', label: 'UFW' },
        { prop: 'phoneBindOpen', label: '手机号绑定' },
        { prop: 'uninstallMenuOpen', label: '卸载菜单栏' },
        { prop: 'transferOpen', label: '转端开关' }
      ]
    }
  },
  computed: {
    appId () {
      return this.$store.getters.appId
    },
    filteredTables () {
      const search = String(this.search || '').toLowerCase()
      return this.tableData.filter(data => {
        return !search || Object.keys(data).some(key => {
          return String(data[key]).toLowerCase().indexOf(search) > -1
        })
      })
    },
    pagedTables () {
      const start = (this.currentPage - 1) * this.pageSize
      return this.filteredTables.slice(start, start + this.pageSize)
    }
  },
  watch: {
    appId (val, oldVal) {
      if (val === oldVal) {
        return
      }
      this.currentPage = 1
      this.fetchData()
    },
    filteredTables () {
      const maxPage = Math.max(1, Math.ceil(this.filteredTables.length / this.pageSize))
      if (this.currentPage > maxPage) {
        this.currentPage = maxPage
      }
    }
  },
  methods: {
    handleRefresh () {
      this.fetchData()
    },
    handleFilterChange () {
      this.currentPage = 1
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
    },
    handleCurrentChange (val) {
      this.currentPage = val
    },
    fetchData () {
      this.loading = true
      Promise.all([
        api.getAppData(),
        api.getCompanyData()
      ]).then(([apps, companies]) => {
        this.tableData = apps || []
        this.companyData = companies || []
      }).finally(() => {
        this.loading = false
      })
    },
    handleUpdateProduct (index, rowData) {
      this.productData = Object.assign({}, rowData)
      this.productDialogVisible = true
    },
    handleUpdateCurrency (index, rowData) {
      const data = Object.assign({}, rowData)
      data.products = data.products ? JSON.parse(data.products) : []
      this.productData = data
      this.currencyDialogVisible = true
    },
    handleAddProduct () {
      const id = this.tableData.length ? this.tableData[this.tableData.length - 1].id : 0
      this.productData = {
        id: id + 1,
        products: [{ id: '', name: '', price: 0, desc: '' }],
        status: 1,
        currency: 'CNY',
        gatewayUrl: 'https://sgw.begindcc.com',
        appKey: this.createRandomStr(26),
        appSecret: this.createRandomStr(32),
        realAuthOpen: false,
        phoneBindOpen: false,
        juvenileOpen: false,
        minAge: 8,
        bizId: '',
        areaId: '',
        ufoGroup: '',
        qyAppKey: '',
        qyGroupId: '',
        uninstallMenuOpen: false
      }
      this.productDialogVisible = true
    },
    handleProductDialogChange (value) {
      if (typeof value === 'object') {
        this.productDialogVisible = false
        this.fetchData()
      } else {
        this.productDialogVisible = value
      }
    },
    handleCurrencyDialogChange (value) {
      this.currencyDialogVisible = value
      this.fetchData()
    },
    handleExport () {
      if (!this.filteredTables || this.filteredTables.length === 0) {
        this.$message.warning('当前暂无可导出的数据')
        return
      }
      const exportData = this.filteredTables.map(row => {
        return {
          ID: row.id,
          游戏名称: row.name,
          公司: this.companyFormatter(row, null, row.companyId),
          UFO分组: row.ufoGroup || '',
          AppKey: row.appKey || '',
          AppSecret: row.appSecret || '',
          QyAppKey: row.qyAppKey || '',
          QyGroupId: row.qyGroupId || '',
          'CP-NotifyUrl': row.notifyUrl || '',
          'CP-H5Url': row.h5LoginUrl || '',
          'CP-微端Url': row.gameUrl || '',
          商品挡位: this.productsToStr(row.products).join(','),
          适龄: row.minAge,
          bizId: row.bizId || '',
          实名: row.realAuthOpen ? '开' : '关',
          防沉迷: row.juvenileOpen ? '开' : '关',
          状态: this.getStatusLabel(row.status),
          Pluto: row.plutoOpen ? '开' : '关',
          UFW: row.ufwOpen ? '开' : '关',
          手机号绑定: row.phoneBindOpen ? '开' : '关',
          卸载菜单栏: row.uninstallMenuOpen ? '开' : '关',
          转端开关: row.transferOpen ? '开' : '关'
        }
      })
      const workbook = XLSX.utils.book_new()
      const worksheet = XLSX.utils.json_to_sheet(exportData)
      XLSX.utils.book_append_sheet(workbook, worksheet, '游戏管理')
      XLSX.writeFile(workbook, `游戏管理-${new Date().getTime()}.xlsx`)
      this.$message.success('数据导出成功')
    },
    productsToStr (products) {
      return products ? f.productsToStr(products) : []
    },
    handleDeleteProduct (id, i) {
      this.$confirm('确定删除该游戏吗?', '提示', { type: 'warning' }).then(() => {
        api.deleteProduct(id).then(() => {
          const index = this.tableData.findIndex(item => item.id === id)
          if (index !== -1) {
            this.tableData.splice(index, 1)
          }
          this.$store.dispatch('ChangeAppList').then(() => {})
          this.$message.success('删除成功')
        })
      })
    },
    createRandomStr (num) {
      let str = ''
      const range = num
      const arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'Xs', 'Y', 'Z']
      for (let i = 0; i < range; i++) {
        const pos = Math.round(Math.random() * (arr.length - 1))
        str += arr[pos]
      }
      return str
    },
    companyFormatter (row, column, cellValue) {
      const item = this.companyData.find(item => item.id === cellValue)
      return item ? cellValue + '-' + item.name : cellValue
    },
    getStatusLabel (status) {
      const found = this.productStatusOption.find(item => item.value === status)
      return found ? found.label : status
    },
    getStatusClass (status) {
      if (status === 1) return 'online'
      if (status === 0) return 'developing'
      if (status === -1) return 'closed'
      return 'developing'
    },
    handleActionCommand (command, row, index) {
      if (command === 'edit') {
        this.handleUpdateProduct(index, row)
      } else if (command === 'currency') {
        this.handleUpdateCurrency(index, row)
      } else if (command === 'delete') {
        this.handleDeleteProduct(row.id, index)
      }
    }
  }
}
</script>

<style scoped>
.product-workspace {
  padding: 16px 24px;
}

.btn-action {
  flex-shrink: 0;
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
}

.btn-action:hover {
  background-color: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}

.reload-wrapper {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.reload-wrapper :deep(.el-button) {
  background-color: var(--bg-reload) !important;
  border-color: var(--border-reload) !important;
  color: var(--text-reload) !important;
  height: 32px;
  padding: 0 16px;
  border-radius: 8px !important;
  font-weight: 600 !important;
}

.reload-wrapper :deep(.el-button:hover) {
  background-color: var(--bg-reload-hover) !important;
  color: var(--text-reload-hover) !important;
  border-color: var(--border-reload-hover) !important;
}

.btn-setting-icon-large {
  width: 32px !important;
  height: 32px !important;
  padding: 0 !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin: 0 !important;
  color: var(--text-muted) !important;
  background: var(--bg-card) !important;
  border-color: var(--border-color) !important;
  border-radius: 8px !important;
}

.btn-setting-icon-large:hover {
  color: var(--text-main) !important;
  background: var(--bg-page) !important;
  border-color: var(--border-hover) !important;
}

.premium-table {
  border-radius: 8px;
  overflow: hidden;
  border: none !important;
  font-size: 13px !important;
  color: var(--text-main) !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif !important;
}

.premium-table::before {
  display: none !important;
}

.premium-table :deep(.el-table__header-wrapper) th,
.premium-table :deep(.el-table__fixed-header-wrapper) th,
.premium-table :deep(.el-table__fixed-right-header-wrapper) th,
.premium-table :deep(th.el-table__fixed-column) {
  background-color: var(--bg-page) !important;
  color: var(--text-muted) !important;
  font-weight: 700 !important;
  padding: 12px 0 !important;
  border-bottom: 1px solid var(--border-color) !important;
}

.premium-table :deep(.el-table__row) td {
  padding: 12px 0 !important;
  border-bottom: 1px solid var(--border-light) !important;
}

.premium-table :deep(.el-table__row) {
  transition: background-color 0.2s ease;
}

.premium-table :deep(.el-table__row:hover) td {
  background-color: var(--bg-hover) !important;
}

.premium-table :deep(.el-table__body tr.hover-row > td),
.premium-table :deep(.el-table__body tr.hover-row.current-row > td),
.premium-table :deep(.el-table__body tr.hover-row.el-table__row--striped > td) {
  background-color: var(--bg-hover) !important;
}

.premium-header-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  color: inherit;
}

.header-icon-hash {
  font-family: Menlo, Monaco, Consolas, monospace;
  font-size: 13.5px;
  font-weight: 900;
  color: inherit;
}

.cell-id,
.cell-text-gray {
  font-family: Menlo, Monaco, Consolas, "Courier New", monospace !important;
  font-size: 12.5px !important;
}

.cell-id {
  font-weight: 600;
  color: var(--text-muted);
}

.cell-text {
  color: var(--text-main);
  font-weight: 500;
}

.cell-text-gray,
.text-muted {
  color: var(--text-muted);
  font-weight: 500;
}

.cell-product-name {
  font-weight: 700 !important;
  font-size: 13.5px !important;
  text-decoration: none !important;
}

.products-tag-container {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  align-items: center;
  min-height: 24px;
  width: 100%;
  cursor: pointer;
}

.product-price-tag {
  background-color: var(--bg-hover) !important;
  border-color: var(--border-color) !important;
  color: var(--text-muted) !important;
  font-weight: 600 !important;
  border-radius: 6px !important;
  transition: all 0.2s ease;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}

.products-tag-container:hover .product-price-tag {
  background-color: rgba(37, 99, 235, 0.06) !important;
  border-color: rgba(37, 99, 235, 0.15) !important;
  color: var(--primary-color) !important;
}

.product-price-tag.more-tag {
  background-color: var(--border-color) !important;
  border-color: var(--border-hover) !important;
  color: var(--text-muted) !important;
}

.status-dot-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 20px;
}

.status-dot-badge .dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.status-dot-badge.online {
  color: #10b981;
  background-color: rgba(16, 185, 129, 0.08);
}

.status-dot-badge.online .dot {
  background-color: #10b981;
}

.status-dot-badge.developing {
  color: var(--primary-color);
  background-color: rgba(37, 99, 235, 0.08);
}

.status-dot-badge.developing .dot {
  background-color: var(--primary-color);
}

.status-dot-badge.closed {
  color: #dc2626;
  background-color: rgba(239, 68, 68, 0.08);
}

.status-dot-badge.closed .dot {
  background-color: #ef4444;
}

.action-btn {
  font-size: 12px;
  border: 1px solid var(--border-color);
  color: var(--text-muted);
  background: var(--bg-card);
  transition: all 0.2s ease;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.action-btn:hover {
  background: var(--bg-hover);
  color: var(--text-main);
  border-color: var(--border-hover);
}

.column-settings-dialog :deep(.el-dialog) {
  border-radius: 12px !important;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
}

.column-settings-dialog :deep(.el-dialog__header) {
  border-bottom: 1px solid var(--border-light);
  padding: 20px 24px 16px !important;
}

.column-settings-dialog :deep(.el-dialog__title) {
  font-weight: 700;
  color: var(--text-main);
  font-size: 16px;
}

.column-settings-dialog .dialog-body-desc {
  font-size: 13px;
  color: var(--text-muted);
  margin-top: -6px;
  margin-bottom: 20px;
  text-align: left;
  line-height: 1.6;
}

.column-settings-dialog .limit-warning {
  color: #f59e0b;
  font-weight: 600;
}

.column-settings-dialog .checkbox-container {
  border: 1px solid var(--border-color);
  border-radius: 10px;
  padding: 20px;
  background-color: var(--bg-page);
  max-height: 400px;
  overflow-y: auto;
}

.column-settings-dialog .dialog-column-group-title {
  font-size: 12px;
  font-weight: 700;
  color: var(--text-muted);
  letter-spacing: 0.5px;
  margin-bottom: 10px;
  margin-top: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.column-settings-dialog .dialog-column-group-title:first-of-type {
  margin-top: 0;
}

.column-settings-dialog .dialog-column-group-title i {
  color: var(--primary-color);
  font-size: 14px;
}

.column-settings-dialog .fixed-columns-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 6px;
}

.column-settings-dialog .fixed-column-card {
  background: var(--bg-hover);
  border: 1px dashed var(--border-hover);
  color: var(--text-muted);
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  user-select: none;
}

.column-settings-dialog .popover-divider {
  height: 1px;
  background: var(--border-color);
  margin: 18px 0;
}

.column-settings-dialog .dialog-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 0;
  width: 100%;
}

.column-settings-dialog .dialog-checkbox-group :deep(.el-checkbox) {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  padding: 8px 14px;
  border-radius: 8px;
  margin-right: 10px !important;
  margin-bottom: 6px !important;
  width: calc(33.33% - 10px);
  box-sizing: border-box;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
}

.column-settings-dialog .dialog-checkbox-group :deep(.el-checkbox:hover) {
  border-color: var(--border-hover);
  background: var(--bg-page);
}

.column-settings-dialog .dialog-checkbox-group :deep(.el-checkbox.is-checked) {
  border-color: rgba(37, 99, 235, 0.4);
  background: rgba(37, 99, 235, 0.02);
}

.column-settings-dialog .dialog-checkbox-group :deep(.el-checkbox__label) {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-main);
}

.column-settings-dialog .dialog-checkbox-group :deep(.el-checkbox__inner) {
  border-radius: 4px;
}

.column-settings-dialog .btn-dialog-action {
  border-radius: 8px !important;
  padding: 8px 18px !important;
  font-weight: 600 !important;
}

.column-settings-dialog :deep(.el-dialog__footer) {
  border-top: 1px solid var(--border-light);
  padding: 16px 24px 20px !important;
  text-align: inherit !important;
}

.column-settings-dialog .dialog-footer {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  width: 100% !important;
}

.right-buttons-group {
  display: flex;
  gap: 12px;
}

:deep(.el-switch.is-disabled) {
  opacity: 0.95;
}

:deep(.el-switch.is-disabled .el-switch__core) {
  cursor: pointer;
}

@media (max-width: 960px) {
  .product-workspace {
    padding: 12px;
  }

  .column-settings-dialog .dialog-checkbox-group :deep(.el-checkbox) {
    width: 100%;
  }
}
</style>
